module.exports = __webpack_public_path__ + "static/hero.07155499.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/clients/hero.jpg
// module id = 933
// module chunks = 241767136424496